module.exports = __webpack_public_path__ + "static/media/image31.2461dd1b.png";